'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { roomQueries } from '@/entities/room'

import { Chip } from './chip'

type Props = {
  onClick: (keyword: string) => void
}

export const KeywordList = ({ onClick }: Props) => {
  const t = useTranslations('search_panel')

  const { data } = useQuery({
    ...roomQueries.recommendSearchKeywords(),
    staleTime: Infinity,
    enabled: false,
  })

  const keywords = data?.keywords ?? []

  if (keywords.length === 0) return null

  const handleKeywordClick = (keyword: string) => () => {
    onClick(keyword)
  }

  return (
    <div className="relative w-[400px] shrink-0 border-gray-100">
      <h2 className="typo-headline2 p-6 font-semibold">
        {t('recommended_keyword.title')}
      </h2>
      <ul className="flex flex-wrap gap-2 px-6 pb-4">
        {keywords.map(keyword => (
          <li key={keyword}>
            <Chip
              className="w-fit min-w-16"
              onClick={handleKeywordClick(keyword)}
            >
              {keyword}
            </Chip>
          </li>
        ))}
      </ul>
    </div>
  )
}
